import { c as _c } from "react/compiler-runtime";
import { CodeBlock } from '@onefootprint/ui';
import formatJson from '../../../utils/format-json';
import JsonView from './json-view';

// The JSON-serialized `Judgment` struct behind an `agent_graph_judgement` artifact.
type Evidence = {
  source?: string;
  excerpt?: string;
  locator?: string;
};
type Judgement = {
  value?: unknown;
  rationale?: string;
  evidence?: Evidence[];
};
const isObjectValue = (value: unknown): value is object => value !== null && typeof value === 'object';
const formatScalar = (value: unknown): string => {
  if (typeof value === 'boolean') return value ? 'True' : 'False';
  if (value === null || value === undefined) return '—';
  return String(value);
};
const parse = (content: string): Judgement | null => {
  try {
    const parsed = JSON.parse(content);
    return parsed && typeof parsed === 'object' ? parsed as Judgement : null;
  } catch {
    return null;
  }
};

// Every field here is agent output of unbounded length, so each carries `break-words`: a token with
// no whitespace has nothing to wrap at and would run past the panel.
const JudgementView = t0 => {
  const $ = _c(6);
  const {
    content
  } = t0;
  let t1;
  let t2;
  if ($[0] !== content) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const judgement = parse(content);
      if (!judgement) {
        t2 = <JsonView content={content} />;
        break bb0;
      }
      const {
        value,
        rationale,
        evidence
      } = judgement;
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <h3 className="text-label-3 text-tertiary">Value</h3>;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      const t4 = isObjectValue(value) ? <CodeBlock language="json" hideHeader={true} maxHeight="24rem">{formatJson(JSON.stringify(value))}</CodeBlock> : <p className="text-body-3 text-primary whitespace-pre-wrap break-words">{formatScalar(value)}</p>;
      let t5;
      if ($[4] !== t4) {
        t5 = <section className="flex flex-col gap-1.5">{t3}{t4}</section>;
        $[4] = t4;
        $[5] = t5;
      } else {
        t5 = $[5];
      }
      t1 = <div className="h-full overflow-auto flex flex-col gap-6">{t5}{rationale && <section className="flex flex-col gap-1.5"><h3 className="text-label-3 text-tertiary">Rationale</h3><p className="text-body-3 text-primary whitespace-pre-wrap break-words">{rationale}</p></section>}{evidence && evidence.length > 0 && <section className="flex flex-col gap-2"><h3 className="text-label-3 text-tertiary">Evidence</h3><ul className="flex flex-col gap-2 m-0 p-0 list-none">{evidence.map(_temp)}</ul></section>}</div>;
    }
    $[0] = content;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
export default JudgementView;
function _temp(item) {
  return <li key={`${item.source ?? ""}-${item.locator ?? ""}-${(item.excerpt ?? "").slice(0, 24)}`} className="flex flex-col gap-2 p-3 rounded-default border border-tertiary bg-secondary">{(item.source || item.locator) && <div className="flex items-center gap-2 flex-wrap">{item.source && <span className="min-w-0 break-words text-snippet-3 px-1 py-0.5 bg-primary text-tertiary border border-tertiary rounded-sm">{item.source}</span>}{item.locator && <span className="min-w-0 break-words text-caption-3 text-tertiary">{item.locator}</span>}</div>}{item.excerpt && <blockquote className="m-0 pl-3 border-l-2 border-tertiary text-body-3 text-secondary whitespace-pre-wrap break-words">{item.excerpt}</blockquote>}</li>;
}